export const jsonToCsv = (data: Array<{[column: string]: string | number}>): Blob =>
    new Blob([data.map((row) => Object.values(row).join(',')).join('\r\n')], {
        type: 'text/csv',
    });
